import { BoltFillColorVioletIcon } from '@zep-us/zus/icons';
import { useTranslation } from 'next-i18next';
import { type QuizType } from '../../type';
import { QUIZ_TYPE_ICON_MAP } from './QuizTypeIcons';
export const QuizTypeSelectorOption = ({
  type
}: {
  type: QuizType;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  return <span className="flex items-center gap-3xs" data-sentry-component="QuizTypeSelectorOption" data-sentry-source-file="QuizTypeSelectorOption.tsx">
      {QUIZ_TYPE_ICON_MAP[type]}
      <span className="text-body-md-medium">
        {type === 'match' ? t('common:quizCard.typeBadge.match') : t(`build.quizType.${type}`)}
      </span>
      {type === 'match' && <BoltFillColorVioletIcon data-testid="match-plan-glyph" width={14} height={14} aria-hidden={true} />}
    </span>;
};